import { Can } from "./Can";

export { AbilityProvider } from "./AbilityProvider";

export default Can;
